export const DIYLink = `https://cleartax.in/filing/?utm_ref=itr_2025_organic_stickyCTA_content_page`;
